module.exports = __webpack_public_path__ + "img/file11.bb2a9ea3.png";